module.exports = __webpack_public_path__ + "img/img_commodity_brand@3x.e62ade80.png";